import { Injectable } from '@angular/core'
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse (value: string): NgbDateStruct | null {
    if (!value) return null
    const parts = value.split('/')
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10)
      const year = parseInt(parts[2], 10)

      if (day && month && year) {
        return { day, month, year }
      }
    }
    return null
  }

  format (date: NgbDateStruct | null): string {
    if (!date) return ''

    const day = date.day.toString().padStart(2, '0')
    const month = date.month.toString().padStart(2, '0')
    const year = date.year.toString()

    return `${day}/${month}/${year}`
  }
}

/**
 * Keeps the reactive form control value as a `DD/MM/YYYY` string while still
 * allowing the ngb datepicker popup to work with `NgbDateStruct`.
 *
 * The default `NgbDateStructAdapter` expects the model to be an object with
 * year/month/day. When a plain string is written to the control (which happens
 * while the user types), that adapter returns `null` and ngb blanks the whole
 * input. Using a string model lets partial values survive typing/backspace.
 */
@Injectable()
export class CustomStringDateAdapter extends NgbDateAdapter<string> {
  fromModel (value: string | NgbDateStruct | null): NgbDateStruct | null {
    if (!value) return null

    // Defensive: also accept an NgbDateStruct object model (e.g. pre-filled
    // values or programmatic setValue) so ngb never receives an unexpected type.
    if (typeof value === 'object') {
      const { day, month, year } = value as NgbDateStruct
      return day && month && year ? { day, month, year } : null
    }

    if (typeof value !== 'string') return null
    const parts = value.split('/')
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10)
      const year = parseInt(parts[2], 10)
      if (day && month && year && parts[2].length === 4) {
        return { day, month, year }
      }
    }
    return null
  }

  toModel (date: NgbDateStruct | null): string | null {
    if (!date) return null
    const day = date.day.toString().padStart(2, '0')
    const month = date.month.toString().padStart(2, '0')
    const year = date.year.toString()
    return `${day}/${month}/${year}`
  }
}
